import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface FridayCheckinPayload {
  message: string;
  userName: string;
  userEmail: string;
}

export interface CheckinConfig {
  is_enabled: boolean;
}

export const fridayCheckinApiClient = createApi({
  reducerPath: 'fridayCheckinApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['CheckinConfig'],
  endpoints: (builder) => ({
    submitFridayCheckin: builder.mutation<{ success: boolean }, FridayCheckinPayload>(
      {
        query: (payload) => ({
          url: 'api/friday-checkin/',
          method: 'POST',
          body: payload,
        }),
      }
    ),
    getCheckinConfig: builder.query<CheckinConfig, void>({
      query: () => 'api/friday-checkin/config/',
      providesTags: ['CheckinConfig'],
    }),
    updateCheckinConfig: builder.mutation<CheckinConfig, { is_enabled: boolean }>(
      {
        query: (payload) => ({
          url: 'api/friday-checkin/config/',
          method: 'PUT',
          body: payload,
        }),
        invalidatesTags: ['CheckinConfig'],
      }
    ),
  }),
});

export const {
  useSubmitFridayCheckinMutation,
  useGetCheckinConfigQuery,
  useUpdateCheckinConfigMutation,
} = fridayCheckinApiClient;
